import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ToasterService } from './toaster.service';
import { config } from '../../../environments/environment';
import { SortDirection } from '../../shared/models/common/sort-direction-enum';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private baseUrl = config.endPointURL;
  private claimsBaseUrl = config.claimsEndPointURL;

  public getBaseUrl() {
    return this.baseUrl;
  }
  constructor(private http: HttpClient, private toastr: ToasterService) { }

  deleteEntity(parent: string, id: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}${parent}/${id}`;
    return this.http.delete(url, { headers }).pipe(
      map((response: any) => this.handleServerResponse(response)),
    );
  }

  deleteConfig(configId: string, slaItemId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.claimsBaseUrl}Config/Delete/${configId}/${slaItemId}`;

    return this.http.delete(url, { headers }).pipe(
      map((response: any) => this.handleServerResponse(response)),
    );
  }


  objectactivation(parent: string, id: string, status: boolean): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = ` ${this.baseUrl}${parent}/Activation/${id}/${status}`;
    return this.http.put(url, { headers }).pipe(
      map((response: any) => this.handleServerResponse(response)),

    );
  }

  objectactivationForSla(configId: string, slaItemId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = ` ${this.claimsBaseUrl}Config/ChangeStatus/${configId}/${slaItemId}`;
    return this.http.put(url, { headers }).pipe(
      map((response: any) => this.handleServerResponse(response)),
    );
  }

  getSortedData(endpointType: 'List' | 'ListAll', sortFilter: string, sortDirection: SortDirection, parent: string, baseUrl: string = this.baseUrl, isSort: boolean = true, payload: { pageSize: number; pageNumber: number }
  ): Observable<any[]> {
    const body = { sortFilter, sortDirection, isSort, payload };
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const fullBaseUrl = `${baseUrl}${parent}/`;
    const url = endpointType === 'List' ? `${fullBaseUrl}List` : `${fullBaseUrl}ListAll`;

    return this.http.post<any[]>(url, body, { headers }).pipe(
      map((response: any) => response.response.items), err => this.handleServerResponse(err));
  }

  private handleServerResponse(response: any): any {
    if (response && response.statusCode >= 400) {
      const errorMessage = response.message || 'An error occurred!';
      this.toastr.onFailure('Error', errorMessage);
      throw new Error(errorMessage);
    }
    return response;
  }

}
